import AuthenticationApi from '../api/authentication';
import createdPersistedState from "vuex-persistedstate";
import axios from 'axios';

const AUTHENTICATING = "AUTHENTICATING",
      AUTHENTICATING_SUCCESS = "AUTHENTICATING_SUCCESS",
      AUTHENTICATING_ERROR = "AUTHENTICATING_ERROR",
      AUTHENTICATING_CUSTOMER = "AUTHENTICATING_CUSTOMER",
      AUTHENTICATING_CUSTOMER_SUCCESS = "AUTHENTICATING_CUSTOMER_SUCCESS",
      AUTHENTICATING_CUSTOMER_ERROR = "AUTHENTICATING_CUSTOMER_ERROR",
      REMIND_PASSWORD = "REMIND_PASSWORD",
      REMIND_PASSWORD_SUCCESS = "REMIND_PASSWORD_SUCCESS",
      REMIND_PASSWORD_ERROR = "REMIND_PASSWORD_ERROR",
      RESTORE_PASSWORD = "RESTORE_PASSWORD",
      RESTORE_PASSWORD_SUCCESS = "RESTORE_PASSWORD_SUCCESS",
      RESTORE_PASSWORD_ERROR = "RESTORE_PASSWORD_ERROR";

export default {
    namespaced: true,
    state: {
        isLoading: false,
        error: null,
        authenticated: localStorage.getItem('access_token') != null || false,
        user_role: localStorage.getItem('user_role') || null,
        user: localStorage.getItem('user') || null,
        access_token: JSON.parse(localStorage.getItem('access_token') || "null"),
        refresh_token: JSON.parse(localStorage.getItem('refresh_token') || "null"),
        menu_permissions: JSON.parse(localStorage.getItem('menu_permissions') || '[]'),
        project_permissions: JSON.parse(localStorage.getItem('project_permissions') || '[]'),
        gallery_link: localStorage.getItem('gallery_link') || null,
    },
    plugins: [createdPersistedState],
    getters: {
        isLoading(state) {
            return state.isLoading;
        },
        hasError(state) {
            return state.error !== null;
        },
        error(state) {
            return state.error;
        },
        isAuthenticated(state) {
          // console.log("store - isAuthenticated", state.authenticated);
          return state.authenticated;
        },
        getUserRole(state) {
          // console.log("store - isAuthenticated", state.authenticated);
          return state.user_role;
        },
        accessToken(state) {
          // console.log("store - accessToken", state.access_token);
          return state.access_token;
        },
        refreshToken(state) {
            return state.refresh_token;
        }
    },
    mutations: {
      [AUTHENTICATING](state) {
          state.isLoading = true;
          state.error = null;
      },
      [AUTHENTICATING_SUCCESS](state, response) {
          state.isLoading = false;
          state.error = null;
          state.access_token = response.access_token;
          localStorage.setItem("access_token", JSON.stringify(state.access_token));
          state.refresh_token = response.refresh_token;
          localStorage.setItem("refresh_token", JSON.stringify(state.refresh_token));
          state.authenticated = true;
          state.user_role = localStorage.getItem('user_role');
          state.user = localStorage.getItem('user');

          state.menu_permissions = response.menu_permissions ? response.menu_permissions : [];
          localStorage.setItem('menu_permissions', JSON.stringify(state.menu_permissions));
          state.project_permissions = response.project_permissions ? response.project_permissions : [];
          localStorage.setItem('project_permissions', JSON.stringify(state.project_permissions));
          state.gallery_link = response.gallery_link ? response.gallery_link : null;
          localStorage.setItem('gallery_link', state.gallery_link);
      },
      [AUTHENTICATING_ERROR](state, error) {
          state.isLoading = false;
          state.error = error;
          state.token = null;
          state.authenticated = false;
          localStorage.removeItem("user_role");
          localStorage.removeItem("user");
      },
      [AUTHENTICATING_CUSTOMER](state) {
        state.isLoading = true;
        state.error = null;
      },
      [AUTHENTICATING_CUSTOMER_SUCCESS](state, response) {
        state.isLoading = false;
        state.error = null;
        state.access_token = response.access_token;
        localStorage.setItem("access_token", JSON.stringify(state.access_token));
        state.refresh_token = response.refresh_token;
        localStorage.setItem("refresh_token", JSON.stringify(state.refresh_token));
        state.authenticated = true;
        state.user_role = localStorage.getItem('user_role');
        state.user = localStorage.getItem('user');
      },
      [AUTHENTICATING_CUSTOMER_ERROR](state, error) {
        state.isLoading = false;
        state.error = error;
        state.token = null;
        state.authenticated = false;
        localStorage.removeItem("user_role");
        localStorage.removeItem("user");
      },
      [REMIND_PASSWORD](state) {
          state.isLoading = true;
          state.error = null;
      },
      [REMIND_PASSWORD_SUCCESS](state, response) {
          state.isLoading = false;
          state.error = null;
      },
      [REMIND_PASSWORD_ERROR](state, error) {
          state.isLoading = false;
          state.error = error;
      },
      [RESTORE_PASSWORD](state) {
          state.isLoading = true;
          state.error = null;
      },
      [RESTORE_PASSWORD_SUCCESS](state, response) {
          state.isLoading = false;
          state.error = null;
      },
      [RESTORE_PASSWORD_ERROR](state, error) {
          state.isLoading = false;
          state.error = error;
      },
    },
    actions: {
      async authenticate({ commit }, params) {
        commit(AUTHENTICATING);
        try {
          let response = await AuthenticationApi.authenticate(params);
          commit(AUTHENTICATING_SUCCESS, response.data);
          return response.data;
        } catch (error) {
          commit(AUTHENTICATING_ERROR, error);
          return null;
        }
      },
      async authenticateCustomer({ commit }, params) {
        commit(AUTHENTICATING_CUSTOMER);
        try {
          // console.log("store - authenticateCustomer", params);
          commit(AUTHENTICATING_CUSTOMER_SUCCESS, params);
          return true;
        } catch (error) {
          commit(AUTHENTICATING_CUSTOMER_ERROR, error);
          return null;
        }
      },
      async remindPassword({ commit }, params) {
        commit(REMIND_PASSWORD);
        try {
          let response = await AuthenticationApi.remindPassword(params);
          commit(REMIND_PASSWORD_SUCCESS, response.data);
          return response.data;
        } catch (error) {
          commit(REMIND_PASSWORD_ERROR, error);
          return null;
        }
      },
      async restorePassword({ commit }, params) {
        commit(RESTORE_PASSWORD);
        try {
          let response = await AuthenticationApi.restorePassword(params);
          commit(RESTORE_PASSWORD_SUCCESS, response.data);
          return response.data;
        } catch (error) {
          commit(RESTORE_PASSWORD_ERROR, error);
          return null;
        }
      },
    }
}



// WEBPACK FOOTER //
// ./src/store/authentication.js